<div [formGroup]="form" class="container text-start was-validated">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="'select'">
      <div class="form-check">
        <span *ngIf="label && options && options.length>0" class="form-label mb-3" [innerHTML]="(label | translation)">
          default</span><span *ngIf="control === 'profile.country' || control === 'profile.birthMonth'">**</span>
        <select [id]="label" class="form-select mt-1"  *ngIf="options && options.length>0 && !control.startsWith('data.favouriteSoccerTeam')"
          [required]="required" [formControlName]="control">
          <ng-container *ngIf="!control.startsWith('profile.country')">
            <option *ngFor="let opt of options" [value]="opt.value" [innerHTML]="(opt.viewValue | translation)"></option>  
          </ng-container>
          <ng-container *ngIf="control.startsWith('profile.country')">
            <option *ngFor="let opt of options" [value]="opt.value" [innerHTML]="('label.country.'+opt.value.toLocaleLowerCase() | translation)">Italy</option>  
          </ng-container>
        </select>
        <select [id]="label" class="form-select mt-1"  *ngIf="options && options.length>0 && control.startsWith('data.favouriteSoccerTeam')"
          [required]="required" [formControlName]="control">
          <option *ngFor="let opt of options" [value]="opt.value" [selected]="this.isTeamSelected == opt.viewValue">{{opt.viewValue}}</option>
        </select>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'number'">
      <div class="form-check">
        <span *ngIf="label" class="form-label mb-3" [innerHTML]="(label | translation)"> default</span><span *ngIf="control === 'profile.birthYear'">**</span>
        <div class="input-group">
          <input class="form-control  mt-1" [min]="min" [max]="max" [id]="label" [type]="type"
             [required]="required" [formControlName]="control">
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchCase="'checkbox'">
      <div class="form-check mt-2 checkboxContainer">
        <input class="form-check-input  mt-1" type="checkbox"  id="flexCheckDefault"
          [required]="required" [formControlName]="control" [checked]="value">
        <div class="labelCheckBox d-flex justify-content-start">
          <span class="form-check-label" for="flexCheckDefault" [innerHTML]="(description | translation)"></span>
          &nbsp;<div *ngIf="linkPrivacyTos" [innerHTML]="(linkPrivacyTos | translation)"></div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <div class="form-check">
        <span *ngIf="label" class="form-label mb-3" [innerHTML]="(label | translation)"> default</span>
        <div class="input-group">
          <input [ngClass]="isMinorPlus?'form-control mt-1' :'form-control  is-invalid mt-1'"  [id]="label" [type]="type"
            [required]="required" [formControlName]="control">
        </div>
      </div>

    </ng-container>
  </ng-container>
</div>